module.exports = __webpack_public_path__ + "static/img/case_detail_01_4.8de64ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_01_4.png
// module id = 2za4
// module chunks = 34